export default __webpack_public_path__ + "static/media/alerts-icon.53bcdb52.svg";